export function removePgSchemaDeclarations(source: string): string {
  return source.replace(/export const \w+ = pgSchema\([\s\S]*?\);\n*/g, '');
}

export function convertSchemaTableInvocations(source: string): { text: string; converted: number } {
  let converted = 0;
  let text = source.replace(/([A-Za-z0-9_]+)\.table\(/g, () => {
    converted += 1;
    return 'pgTable(';
  });
  text = text.replace(/([A-Za-z0-9_]+)\.view\(/g, () => {
    converted += 1;
    return 'pgView(';
  });
  text = text.replace(/([A-Za-z0-9_]+)\.materializedView\(/g, () => {
    converted += 1;
    return 'pgMaterializedView(';
  });
  text = text.replace(/([A-Za-z0-9_]+)\.enum\(/g, () => {
    converted += 1;
    return 'pgEnum(';
  });
  text = text.replace(/([A-Za-z0-9_]+)\.sequence\(/g, () => {
    converted += 1;
    return 'pgSequence(';
  });
  return { text, converted };
}
